module.exports = __webpack_public_path__ + "img/scene4-11.ca772715.jpg";